var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('v-app',[_c('v-main',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header card-header-success"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }